// flow ids (for v2 flows) which correspond to flow definitions and reducers (`identity.flows[FlowId]`)
export const FlowId = {
  ACCOUNT_AGG: 'account-agg',
  CREDIT_SCORE: 'credit-score',
  EXAMPLE: 'example-flow',
  NO_SECURITY_QUESTION: 'NO_SECURITY_QUESTION',
  ONBOARDING_GENERIC: 'ONBOARDING_GENERIC',
};

// web only: used by the `<Auth>` component to map to React components
export const ComponentId = {
  EXAMPLE: 'EXAMPLE',
  PLAID_LINK: 'PLAID_LINK',
};

export enum FlowStoppedReason {
  CLOSED = 'CLOSED',
  COMPLETE = 'COMPLETE',
}

export const PLAID_TERMS_OF_SERVICE_ACKNOWLEDGEMENT_TYPE = 'PLAID_LINK';

export const NwPlusRewardableEvent = {
  ACTIVATED_TU: 'ACTIVATED_TU',
  LINKED_ALL_ACCOUNT_TYPES: 'LINKED_ALL_ACCOUNT_TYPES',
  LINKED_CREDIT_CARD_ACCOUNT: 'LINKED_CREDIT_CARD_ACCOUNT',
  LOGGED_INTO_NERDWALLET_WEB: 'LOGGED_INTO_NERDWALLET_WEB',
  LINKED_INVESTMENT_ACCOUNT: 'LINKED_INVESTMENT_ACCOUNT',
  LINKED_LOAN_ACCOUNT: 'LINKED_LOAN_ACCOUNT',
  LINKED_SAVINGS_ACCOUNT: 'LINKED_SAVINGS_ACCOUNT',
};
